/* Little Faith v2: Groesse muss aktiv gewaehlt werden + Lieferdatum */
(function () {
  var chosen = /[?&]variant=\d+/.test(location.search);
  var RX = /gr(ö|oe|o)(ß|ss)e|size/i;

  function sizeFieldsets() {
    var out = [];
    document.querySelectorAll('variant-picker fieldset').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      if (lg && RX.test(lg.textContent || '')) out.push(fs);
    });
    return out;
  }

  function apply() {
    var list = sizeFieldsets();
    if (!list.length) { document.body.classList.remove('lf-size-unset', 'lf-size-warn'); return; }
    list.forEach(function (fs) {
      if (!fs.classList.contains('lf-size-fs')) fs.classList.add('lf-size-fs');
      if (!fs.querySelector('.lf-size-msg')) {
        var p = document.createElement('p');
        p.className = 'lf-size-msg';
        p.setAttribute('role', 'alert');
        p.textContent = 'Bitte wähle zuerst eine Größe.';
        fs.appendChild(p);
      }
    });
    if (document.body.classList.contains('lf-size-unset') === chosen) {
      document.body.classList.toggle('lf-size-unset', !chosen);
    }
  }

  function warn() {
    var fs = sizeFieldsets()[0];
    document.body.classList.remove('lf-size-warn');
    void document.body.offsetWidth;
    document.body.classList.add('lf-size-warn');
    if (fs && fs.scrollIntoView) fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function guard(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('fieldset.lf-size-fs label')) {
      chosen = true;
      document.body.classList.remove('lf-size-unset', 'lf-size-warn');
      return;
    }
    if (chosen || !document.body.classList.contains('lf-size-unset')) return;
    if (t.closest('.add-to-cart-button, .accelerated-checkout-block, product-form-component button[type="submit"]')) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      warn();
    }
  }

  function guardSubmit(e) {
    if (chosen || !document.body.classList.contains('lf-size-unset')) return;
    var f = e.target;
    if (f && f.closest && f.closest('product-form-component')) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      warn();
    }
  }

  function eta() {
    document.querySelectorAll('[data-lf-eta]:not([data-lf-done])').forEach(function (el) {
      var p = (el.getAttribute('data-lf-eta') || '2,4').split(',');
      function add(n) {
        var d = new Date(), c = 0;
        while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) c++; }
        return d;
      }
      try {
        var f = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
        el.textContent = f.format(add(+p[0])) + ' bis ' + f.format(add(+p[1]));
        el.setAttribute('data-lf-done', '1');
      } catch (err) {}
    });
  }

  function run() { apply(); eta(); }

  window.addEventListener('click', guard, true);
  window.addEventListener('submit', guardSubmit, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();

  var timer;
  function start() {
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(run, 80); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
